import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Grid,
  Text,
} from "@chakra-ui/react";
import { Plugins } from "../../../plugins";
import { PluginType } from "../../../plugins/ai";

type IProps = {
  isOpen: boolean;
  onClose: () => void;
  onPluginSelect: (plugin: PluginType) => void;
};

const AddPlugin = ({ isOpen, onClose, onPluginSelect }: IProps) => {
  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="xl">
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader bg="neutral.950">Plugins</DrawerHeader>

        <DrawerBody bg={"neutral.950"} py={"1rem"}>
          {/* Plugins Grid */}
          {Object.entries(Plugins).map(([pluginKey, pluginValue]) => {
            return (
              <Box key={pluginKey} mb={"1rem"}>
                <Text fontSize={"xl"} mb={2} fontWeight="bold">
                  {pluginKey}
                </Text>
                <Grid templateColumns="repeat(3, 1fr)" gap={4}>
                  {pluginValue.map((pluginItem) => (
                    <Box
                      cursor={"pointer"}
                      width={"full"}
                      bg="neutral.800"
                      p={"1rem"}
                      key={pluginItem.name}
                      borderRadius="md"
                      onClick={() => onPluginSelect(pluginItem)}
                    >
                      <Text fontSize="md" fontWeight={"bold"}>
                        {pluginItem.name}
                      </Text>
                      <Text fontSize="sm">{pluginItem.description}</Text>
                    </Box>
                  ))}
                </Grid>
              </Box>
            );
          })}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default AddPlugin;
